import type React from 'react'
import { cn } from '@/frontend/utils'

export const H2 = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <h2 className={cn('font-bold text-2xl lg:font-bold lg:text-3xl', className)}>{children}</h2>
  )
}
